"use strict";

exports.__esModule = true;
exports.convertToID = void 0;
var convertToID = exports.convertToID = function convertToID(baseName) {
  return encodeURIComponent(baseName.trim().replace(/[`~!@#$%^&*()_|+=?;:'",.<>\{\}\[\]\\\/]/gi, "").replace(/\s/gi, "-").toLowerCase());
};